import { render, staticRenderFns } from "./BucketAdminCreated.vue?vue&type=template&id=63627416&"
import script from "./BucketAdminCreated.vue?vue&type=script&lang=js&"
export * from "./BucketAdminCreated.vue?vue&type=script&lang=js&"
import style0 from "./BucketAdminCreated.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports